module.exports = __webpack_public_path__ + "media/images/facebook-3604085a6b719889cadae138210c9d81.svg";